import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";

export const lineItemsTotal = (items) =>
  (items || []).reduce((s, it) => s + (parseFloat(it.qty) || 0) * (parseFloat(it.unit_price) || 0), 0);

export const LineItemsEditor = ({ items = [], onChange }) => {
  const update = (next) => {
    const total = Math.round(lineItemsTotal(next) * 100) / 100;
    onChange(next, next.length ? total : null);
  };
  const setItem = (i, k, v) => update(items.map((it, idx) => (idx === i ? { ...it, [k]: v } : it)));
  const total = lineItemsTotal(items);
  return (
    <div className="border border-slate-200 rounded-md p-3 bg-slate-50/50" data-testid="line-items-editor">
      {items.length > 0 && (
        <div className="grid grid-cols-[1fr_60px_92px_76px_28px] gap-2 text-[11px] text-slate-400 mb-1 px-0.5">
          <span>Description</span><span>Qty</span><span>Unit price</span><span className="text-right">Total</span><span />
        </div>
      )}
      {items.map((it, i) => (
        <div key={i} className="grid grid-cols-[1fr_60px_92px_76px_28px] gap-2 mb-1.5 items-center">
          <Input data-testid={`li-desc-${i}`} value={it.description || ""} onChange={(e) => setItem(i, "description", e.target.value)} placeholder="Item / work description" className="bg-white h-8 text-sm" />
          <Input data-testid={`li-qty-${i}`} type="number" min="0" value={it.qty ?? ""} onChange={(e) => setItem(i, "qty", e.target.value)} className="bg-white h-8 text-sm" />
          <Input data-testid={`li-price-${i}`} type="number" min="0" step="0.01" value={it.unit_price ?? ""} onChange={(e) => setItem(i, "unit_price", e.target.value)} className="bg-white h-8 text-sm" />
          <div className="text-right text-sm text-slate-700 font-medium">{(((parseFloat(it.qty) || 0) * (parseFloat(it.unit_price) || 0)) || 0).toFixed(2)}</div>
          <button type="button" data-testid={`li-remove-${i}`} onClick={() => update(items.filter((_, idx) => idx !== i))} className="text-slate-300 hover:text-red-600 transition-colors">
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      ))}
      <div className="flex items-center justify-between mt-1">
        <Button type="button" variant="outline" size="sm" data-testid="li-add" className="h-7 text-xs"
          onClick={() => update([...items, { description: "", qty: 1, unit_price: "" }])}>
          <Plus className="h-3.5 w-3.5 mr-1" />Add line item
        </Button>
        {items.length > 0 && <div className="text-sm font-semibold text-slate-800" data-testid="li-total">Total: {total.toFixed(2)}</div>}
      </div>
      {items.length > 0 && <p className="text-[11px] text-slate-400 mt-1.5">Selling price is auto-filled from the line items total.</p>}
    </div>
  );
};
